/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: transportation.fga
 * Run: pnpm run gen:permissions -- transportation
 */

import type { ModulePermissions } from './types';

export const transportationPermissions = {
  module: 'transportation',
  displayName: 'Transportation',
  entities: [
    {
      name: 'asset',
      displayName: 'Asset',
      permissions: [
        { key: 'assetRead', action: 'Read', category: 'crud' },
        { key: 'assetCreate', action: 'Create', category: 'crud' },
        { key: 'assetUpdate', action: 'Update', category: 'crud' },
        { key: 'assetDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'assetType',
      displayName: 'Asset Type',
      permissions: [
        { key: 'assetTypeRead', action: 'Read', category: 'crud' },
        { key: 'assetTypeCreate', action: 'Create', category: 'crud' },
        { key: 'assetTypeUpdate', action: 'Update', category: 'crud' },
        { key: 'assetTypeDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'containerType',
      displayName: 'Container Type',
      permissions: [
        { key: 'containerTypeRead', action: 'Read', category: 'crud' },
        { key: 'containerTypeCreate', action: 'Create', category: 'crud' },
        { key: 'containerTypeUpdate', action: 'Update', category: 'crud' },
        { key: 'containerTypeDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'detention',
      displayName: 'Detention',
      permissions: [
        { key: 'detentionRead', action: 'Read', category: 'crud' },
        { key: 'detentionCreate', action: 'Create', category: 'crud' },
        { key: 'detentionUpdate', action: 'Update', category: 'crud' },
        { key: 'detentionDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'driver',
      displayName: 'Driver',
      permissions: [
        { key: 'driverRead', action: 'Read', category: 'crud' },
        { key: 'driverCreate', action: 'Create', category: 'crud' },
        { key: 'driverUpdate', action: 'Update', category: 'crud' },
        { key: 'driverDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'driverCertification',
      displayName: 'Driver Certification',
      permissions: [
        { key: 'driverCertificationRead', action: 'Read', category: 'crud' },
        {
          key: 'driverCertificationCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'driverCertificationUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'driverCertificationDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'freightForwarder',
      displayName: 'Freight Forwarder',
      permissions: [
        { key: 'freightForwarderRead', action: 'Read', category: 'crud' },
        { key: 'freightForwarderCreate', action: 'Create', category: 'crud' },
        { key: 'freightForwarderUpdate', action: 'Update', category: 'crud' },
        { key: 'freightForwarderDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'freightLane',
      displayName: 'Freight Lane',
      permissions: [
        { key: 'freightLaneRead', action: 'Read', category: 'crud' },
        { key: 'freightLaneCreate', action: 'Create', category: 'crud' },
        { key: 'freightLaneUpdate', action: 'Update', category: 'crud' },
        { key: 'freightLaneDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'freightLaneCost',
      displayName: 'Freight Lane Cost',
      permissions: [
        { key: 'freightLaneCostRead', action: 'Read', category: 'crud' },
        { key: 'freightLaneCostCreate', action: 'Create', category: 'crud' },
        { key: 'freightLaneCostUpdate', action: 'Update', category: 'crud' },
        { key: 'freightLaneCostDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'freightLaneRoute',
      displayName: 'Freight Lane Route',
      permissions: [
        { key: 'freightLaneRouteRead', action: 'Read', category: 'crud' },
        { key: 'freightLaneRouteCreate', action: 'Create', category: 'crud' },
        { key: 'freightLaneRouteUpdate', action: 'Update', category: 'crud' },
        { key: 'freightLaneRouteDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'freightLine',
      displayName: 'Freight Line',
      permissions: [
        { key: 'freightLineRead', action: 'Read', category: 'crud' },
        { key: 'freightLineCreate', action: 'Create', category: 'crud' },
        { key: 'freightLineUpdate', action: 'Update', category: 'crud' },
        { key: 'freightLineDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'hauler',
      displayName: 'Hauler',
      permissions: [
        { key: 'haulerRead', action: 'Read', category: 'crud' },
        { key: 'haulerAdd', action: 'Add', category: 'custom' },
        { key: 'haulerRemove', action: 'Remove', category: 'custom' },
      ],
    },
    {
      name: 'route',
      displayName: 'Route',
      permissions: [
        { key: 'routeRead', action: 'Read', category: 'crud' },
        { key: 'routeCreate', action: 'Create', category: 'crud' },
        { key: 'routeUpdate', action: 'Update', category: 'crud' },
        { key: 'routeDelete', action: 'Delete', category: 'crud' },
        { key: 'routeAssign', action: 'Assign', category: 'custom' },
        { key: 'routeExecute', action: 'Execute', category: 'custom' },
        {
          key: 'routeManageLifecycle',
          action: 'Manage Lifecycle',
          category: 'custom',
        },
        { key: 'routeReadDriver', action: 'Read Driver', category: 'custom' },
        {
          key: 'routeReadServices',
          action: 'Read Services',
          category: 'custom',
        },
        { key: 'routeReadStatus', action: 'Read Status', category: 'custom' },
      ],
    },
    {
      name: 'routeFreight',
      displayName: 'Route Freight',
      permissions: [
        { key: 'routeFreightRead', action: 'Read', category: 'crud' },
        { key: 'routeFreightCreate', action: 'Create', category: 'crud' },
        { key: 'routeFreightUpdate', action: 'Update', category: 'crud' },
        { key: 'routeFreightDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'routeValidationOverride',
      displayName: 'Route Validation Override',
      permissions: [
        {
          key: 'routeValidationOverrideRead',
          action: 'Read',
          category: 'crud',
        },
        {
          key: 'routeValidationOverrideCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'routeValidationOverrideUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'routeValidationOverrideDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'service',
      displayName: 'Service',
      permissions: [
        { key: 'serviceRead', action: 'Read', category: 'crud' },
        { key: 'serviceCreate', action: 'Create', category: 'crud' },
        { key: 'serviceUpdate', action: 'Update', category: 'crud' },
        { key: 'serviceDelete', action: 'Delete', category: 'crud' },
        { key: 'serviceAssign', action: 'Assign', category: 'custom' },
        { key: 'serviceExecute', action: 'Execute', category: 'custom' },
        {
          key: 'serviceManageLifecycle',
          action: 'Manage Lifecycle',
          category: 'custom',
        },
        {
          key: 'serviceReadAccount',
          action: 'Read Account',
          category: 'custom',
        },
        { key: 'serviceReadAsset', action: 'Read Asset', category: 'custom' },
        { key: 'serviceReadDriver', action: 'Read Driver', category: 'custom' },
        { key: 'serviceReadHauler', action: 'Read Hauler', category: 'custom' },
        { key: 'serviceReadStatus', action: 'Read Status', category: 'custom' },
        {
          key: 'serviceReadTrailer',
          action: 'Read Trailer',
          category: 'custom',
        },
        { key: 'serviceReadTruck', action: 'Read Truck', category: 'custom' },
        { key: 'serviceVoid', action: 'Void', category: 'custom' },
      ],
    },
    {
      name: 'serviceType',
      displayName: 'Service Type',
      permissions: [
        { key: 'serviceTypeRead', action: 'Read', category: 'crud' },
        { key: 'serviceTypeCreate', action: 'Create', category: 'crud' },
        { key: 'serviceTypeUpdate', action: 'Update', category: 'crud' },
        { key: 'serviceTypeDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'serviceTypeTaskDefinition',
      displayName: 'Service Type Task Definition',
      permissions: [
        {
          key: 'serviceTypeTaskDefinitionRead',
          action: 'Read',
          category: 'crud',
        },
        {
          key: 'serviceTypeTaskDefinitionCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'serviceTypeTaskDefinitionUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'serviceTypeTaskDefinitionDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'shippingCarrier',
      displayName: 'Shipping Carrier',
      permissions: [
        { key: 'shippingCarrierRead', action: 'Read', category: 'crud' },
        { key: 'shippingCarrierCreate', action: 'Create', category: 'crud' },
        { key: 'shippingCarrierUpdate', action: 'Update', category: 'crud' },
        { key: 'shippingCarrierDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'task',
      displayName: 'Task',
      permissions: [
        { key: 'taskRead', action: 'Read', category: 'crud' },
        { key: 'taskCreate', action: 'Create', category: 'crud' },
        { key: 'taskUpdate', action: 'Update', category: 'crud' },
        { key: 'taskDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'taskService',
      displayName: 'Task Service',
      permissions: [
        { key: 'taskServiceRead', action: 'Read', category: 'crud' },
        { key: 'taskServiceCreate', action: 'Create', category: 'crud' },
        { key: 'taskServiceUpdate', action: 'Update', category: 'crud' },
        { key: 'taskServiceDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'trailer',
      displayName: 'Trailer',
      permissions: [
        { key: 'trailerRead', action: 'Read', category: 'crud' },
        { key: 'trailerCreate', action: 'Create', category: 'crud' },
        { key: 'trailerUpdate', action: 'Update', category: 'crud' },
        { key: 'trailerDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'transportationType',
      displayName: 'Transportation Type',
      permissions: [
        { key: 'transportationTypeRead', action: 'Read', category: 'crud' },
        { key: 'transportationTypeCreate', action: 'Create', category: 'crud' },
        { key: 'transportationTypeUpdate', action: 'Update', category: 'crud' },
        { key: 'transportationTypeDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'truck',
      displayName: 'Truck',
      permissions: [
        { key: 'truckRead', action: 'Read', category: 'crud' },
        { key: 'truckCreate', action: 'Create', category: 'crud' },
        { key: 'truckUpdate', action: 'Update', category: 'crud' },
        { key: 'truckDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'vehicle',
      displayName: 'Vehicle',
      permissions: [
        { key: 'vehicleRead', action: 'Read', category: 'crud' },
        { key: 'vehicleCreate', action: 'Create', category: 'crud' },
        { key: 'vehicleUpdate', action: 'Update', category: 'crud' },
        { key: 'vehicleDelete', action: 'Delete', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Transportation module
 */
export type TransportationPermissionKey =
  | 'assetRead'
  | 'assetCreate'
  | 'assetUpdate'
  | 'assetDelete'
  | 'assetTypeRead'
  | 'assetTypeCreate'
  | 'assetTypeUpdate'
  | 'assetTypeDelete'
  | 'containerTypeRead'
  | 'containerTypeCreate'
  | 'containerTypeUpdate'
  | 'containerTypeDelete'
  | 'detentionRead'
  | 'detentionCreate'
  | 'detentionUpdate'
  | 'detentionDelete'
  | 'driverRead'
  | 'driverCreate'
  | 'driverUpdate'
  | 'driverDelete'
  | 'driverCertificationRead'
  | 'driverCertificationCreate'
  | 'driverCertificationUpdate'
  | 'driverCertificationDelete'
  | 'freightForwarderRead'
  | 'freightForwarderCreate'
  | 'freightForwarderUpdate'
  | 'freightForwarderDelete'
  | 'freightLaneRead'
  | 'freightLaneCreate'
  | 'freightLaneUpdate'
  | 'freightLaneDelete'
  | 'freightLaneCostRead'
  | 'freightLaneCostCreate'
  | 'freightLaneCostUpdate'
  | 'freightLaneCostDelete'
  | 'freightLaneRouteRead'
  | 'freightLaneRouteCreate'
  | 'freightLaneRouteUpdate'
  | 'freightLaneRouteDelete'
  | 'freightLineRead'
  | 'freightLineCreate'
  | 'freightLineUpdate'
  | 'freightLineDelete'
  | 'haulerRead'
  | 'haulerAdd'
  | 'haulerRemove'
  | 'routeRead'
  | 'routeCreate'
  | 'routeUpdate'
  | 'routeDelete'
  | 'routeAssign'
  | 'routeExecute'
  | 'routeManageLifecycle'
  | 'routeReadDriver'
  | 'routeReadServices'
  | 'routeReadStatus'
  | 'routeFreightRead'
  | 'routeFreightCreate'
  | 'routeFreightUpdate'
  | 'routeFreightDelete'
  | 'routeValidationOverrideRead'
  | 'routeValidationOverrideCreate'
  | 'routeValidationOverrideUpdate'
  | 'routeValidationOverrideDelete'
  | 'serviceRead'
  | 'serviceCreate'
  | 'serviceUpdate'
  | 'serviceDelete'
  | 'serviceAssign'
  | 'serviceExecute'
  | 'serviceManageLifecycle'
  | 'serviceReadAccount'
  | 'serviceReadAsset'
  | 'serviceReadDriver'
  | 'serviceReadHauler'
  | 'serviceReadStatus'
  | 'serviceReadTrailer'
  | 'serviceReadTruck'
  | 'serviceVoid'
  | 'serviceTypeRead'
  | 'serviceTypeCreate'
  | 'serviceTypeUpdate'
  | 'serviceTypeDelete'
  | 'serviceTypeTaskDefinitionRead'
  | 'serviceTypeTaskDefinitionCreate'
  | 'serviceTypeTaskDefinitionUpdate'
  | 'serviceTypeTaskDefinitionDelete'
  | 'shippingCarrierRead'
  | 'shippingCarrierCreate'
  | 'shippingCarrierUpdate'
  | 'shippingCarrierDelete'
  | 'taskRead'
  | 'taskCreate'
  | 'taskUpdate'
  | 'taskDelete'
  | 'taskServiceRead'
  | 'taskServiceCreate'
  | 'taskServiceUpdate'
  | 'taskServiceDelete'
  | 'trailerRead'
  | 'trailerCreate'
  | 'trailerUpdate'
  | 'trailerDelete'
  | 'transportationTypeRead'
  | 'transportationTypeCreate'
  | 'transportationTypeUpdate'
  | 'transportationTypeDelete'
  | 'truckRead'
  | 'truckCreate'
  | 'truckUpdate'
  | 'truckDelete'
  | 'vehicleRead'
  | 'vehicleCreate'
  | 'vehicleUpdate'
  | 'vehicleDelete';
